import { Action, createReducer, on } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';
import { GamesActions } from '../actions/actions-type.action';

export interface GamesState {
    games: any[];
    platforms: any[];
    isLoading: boolean;
    error: BadResponseWithError | null;
}

const initialState: GamesState = {
    games: [],
    platforms: [],
    isLoading: false,
    error: null,
};

const reducer = createReducer(
    initialState,
    on(GamesActions.fetchPlatformsRequests, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GamesActions.fetchPlatformsSuccess, (state, { payload }) => ({
        ...state,
        platforms: payload || [],
        isLoading: false,
    })),
    on(GamesActions.fetchGamesRequests, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GamesActions.fetchGamesSuccess, (state, { payload }) => ({
        ...state,
        games: payload.items || [],
        isLoading: false,
    })),
    on(GamesActions.fetchGamesFailure, (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload,
    })),

    on(GamesActions.createGameRequests, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GamesActions.createGameSuccess, (state, { payload }) => ({
        ...state,
        games: [...state.games, payload],
        isLoading: false,
    })),
    on(GamesActions.createGameFailure, (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload,
    })),

    on(GamesActions.updateGameRequests, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GamesActions.updateGameSuccess, (state, { body }) => ({
        ...state,
        games: state.games.map((g) =>
            g.id === body.id ? { ...g, ...body } : g
        ),
        isLoading: false,
    })),
    on(GamesActions.updateGameFailure, (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload,
    })),

    on(GamesActions.deleteGameRequests, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GamesActions.deleteGameSuccess, (state, { gameId }) => ({
        ...state,
        games: state.games.filter((g) => g.id !== gameId),
        isLoading: false,
    })),
    on(GamesActions.deleteGameFailure, (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload,
    }))
);

export const gamesReducer = (state: GamesState | undefined, action: Action) =>
    reducer(state, action);
